import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (data.cliente?.length === 0 || data.cliente === null)
        response.push(<Box>Selecione um Cliente.</Box>)

    if (data.empresa?.length === 0 || data.empresa === null)
        response.push(<Box>Selecione uma Empresa.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData